import React, {PropTypes} from "react";
import {connect} from "react-redux";
import SearchForm from "./SearchForm2";
import {BootstrapTable, TableHeaderColumn as TableHeaderColumn} from "react-bootstrap-table";
import * as actions from "../../redux/actions/leaveActions";
import LinearProgress from "material-ui/LinearProgress";

let min = new Date();
min.setDate(min.getDate() - 2);
let max = new Date();
max.setDate(max.getDate() - 1);
let from = new Date();
from.setDate(from.getDate() - 7);
let to = new Date();
var default_search = {
  startDate: from,
  endDate: to
};
class LeaveTeamWeekly extends React.Component {

  constructor() {
    super();
  }

  checkNull(cell, row, formatExtraData, rowIdx) {
    if (cell == null || cell == undefined || cell == "") {
      return 'NA';
    }
    else return cell;
  }

  componentWillUnmount() {
    this.props.dispatch(actions.loadDefault());

  }

  render() {
    console.log(this.props.teamWeekly);
    var keys = new Array();
    let i = 0;
    if (this.props.weekly.length != 0) {
      for (var p in this.props.weekly[0].weekLeaveStatus) {
        keys[i] = p;
        i++;
      }
      keys.sort();

    }

    return (
      <div>
        <div role="tabpanel" className="tab-pane" id="apply">
          <div className="row clearfix">
            <br/>
            <h2 style={{marginTop: '5'}}>Team Weekly Details</h2>
            <SearchForm dates={default_search} isVertical = {this.props.isVertical}/>
            {this.props.loading > 0 ? <LinearProgress mode="indeterminate" style={{padding: '2px', width: '100%'}}/> :
              <label></label> }
            <div className="col-md-12"
                 style={{
                   borderBottomStyle: 'solid',
                   paddingBottom: '5px',
                   borderLeftStyle: 'solid',
                   borderLeftColor: 'rgb(92, 184, 92)',
                   borderWidth: '1px',
                   borderBottomColor: '#008bcf',
                 }}
            >
              <BootstrapTable
                height="400"
                containerStyle={{paddingTop: 0}}
                data={this.props.teamWeekly}>
                <TableHeaderColumn
                  dataSort={true}
                  hidden={true}
                  isKey={true}
                  width={130}
                  dataField="empId">Emp Id</TableHeaderColumn>
                <TableHeaderColumn
                  dataSort={true}
                  filter={{type: "TextFilter", placeHolder: "Emp name"}}
                  width={110} dataField="empName" dataFormat={this.checkNull}>Employee Name</TableHeaderColumn>

                {keys.map((node, index)=> {
                  console.log(node.toString());
                  let dat = new Date(node);
                  return <TableHeaderColumn dataSort={false}
                                            width={80}
                                            dataField={node.toString()}>{dat.toString().substr(0, 10)}</TableHeaderColumn>
                })}

              </BootstrapTable>
            </div>

          </div>
        </div>
      </div>
    );
  }

}

LeaveTeamWeekly.propTypes = {};

function mapStateToProps(state, ownState) {
  var final = new Array();
  var i = 0;
  if (state.leave[5].teamWeekly.length != 0) {
    for (var p in state.leave[5].teamWeekly) {

      final[i] = new Object();
      final[i].empId = state.leave[5].teamWeekly[p].empId;
      final[i].empName = state.leave[5].teamWeekly[p].empName;
      for (var key in state.leave[5].teamWeekly[p].weekLeaveStatus) {

        final[i][key] = state.leave[5].teamWeekly[p].weekLeaveStatus[key];
      }
      i++;
    }
  }
  return {
    state: state,
    teamWeekly: final,
    weekly: state.leave[5].teamWeekly,
    loading: state.ajaxCallsInProgress
  };

}


export default connect(mapStateToProps)(LeaveTeamWeekly);




/** WEBPACK FOOTER **
 ** ./src/feature/leave/LeaveTeamWeekly.js
 **/